import { advanceStatus, type StatusTransitions } from "@/shared/utils/statusProgress";

import { PayoutStatus } from "../services/paymentsPayout.service";

/**
 * Mirror of coloca-nest `PAYOUT_TRANSITIONS` (`src/coloca/payments/state/payout-transitions.ts`): the only
 * moves the backend ever makes. FAILED, CANCELLED and REVERSED are final; PAID can still be REVERSED (a
 * clawback).
 */
const PAYOUT_TRANSITIONS: StatusTransitions<PayoutStatus> = {
  [PayoutStatus.CREATED]: [PayoutStatus.PROCESSING, PayoutStatus.CANCELLED, PayoutStatus.FAILED],
  [PayoutStatus.PROCESSING]: [PayoutStatus.PAID, PayoutStatus.FAILED, PayoutStatus.REVERSED],
  [PayoutStatus.PAID]: [PayoutStatus.REVERSED],
  [PayoutStatus.FAILED]: [],
  [PayoutStatus.CANCELLED]: [],
  [PayoutStatus.REVERSED]: [],
};

/**
 * The payout status to show after one more reading — from the socket, the poll, or the create response the
 * live channel upgrades: a paid payout never goes back to "in progress". See `advanceStatus`.
 */
export function advancePayoutStatus(
  current: PayoutStatus | null,
  incoming: string | null | undefined,
): PayoutStatus | null {
  return advanceStatus(PAYOUT_TRANSITIONS, current, incoming);
}
